import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "wrapper"
}
const _hoisted_2 = {
  key: 0,
  class: "design-message-row"
}
const _hoisted_3 = { class: "row-value" }
const _hoisted_4 = {
  key: 1,
  class: "design-message-row"
}
const _hoisted_5 = { class: "row-value" }
const _hoisted_6 = { class: "content-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        ($setup.props.type === $setup.BuilderMessageType.BUILD_PRICE)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.desktopMessageParts, (part) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createTextVNode(_toDisplayString(part), 1),
                  _cache[0] || (_cache[0] = _createElementVNode("span", { class: "row-value-bold" }, " Build Expression of Interest Form", -1)),
                  _createTextVNode(_toDisplayString($setup.buildPriceMessagePartTwo), 1)
                ]))
              }), 256))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.desktopMessageParts, (part) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(part), 1))
              }), 256))
            ])),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "button default primary message",
            onClick: $setup.handleButtonClick
          }, _toDisplayString($setup.buttonText), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}